// You can write more code here
import { uiAssetsPath } from '@/app/constants';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { TilemapLevels } from '@/game/GameComponents/PhaserGame/main';
import TutorializationManager from '@/game/GameComponents/PhaserGame/Tutorialization/TutorializationManager';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { RewardsManager } from '@/game/GameComponents/PhaserGame/Utils/RewardsManager';
import Portal from '@/game/prefabs/World/Portal';
import TilemapScene from './TilemapScenes/TilemapScene';

/* START OF COMPILED CODE */

import DailiesPanel from '@/game/prefabs/DailyActivities/DailiesPanel';
import LessonPanel from '@/game/prefabs/Lesson/LessonPanel';
import MasteriesPanel from '@/game/prefabs/Masteries/MasteriesPanel';
import GuidancePanel from '@/game/prefabs/WorldUI/GuidancePanel';
import HUD from '@/game/prefabs/WorldUI/HUD/HUD';
import MentorIntroductionPanel from '@/game/prefabs/WorldUI/MentorIntroductionPanel';
import NextLevelModal from '@/game/prefabs/WorldUI/NextLevelModal';
import npcDialogue from '@/game/prefabs/WorldUI/NpcDialogue/npcDialogue';
import QuitToMenuModal from '@/game/prefabs/WorldUI/QuitToMenuModal';
import RewardFeedbackPanel from '@/game/prefabs/WorldUI/RewardFeedbackPanel';
import WalkthroughPanel from './WalkthroughPanel';
/* START-USER-IMPORTS */
/* START-USER-IMPORTS */
import trackMixpanelEvent from '@/common/utils/mixpanel';
import {
  GameInstance,
  getStudent,
} from '@/game/GameComponents/PhaserGame/GameInstance';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import { StudentManager } from '@/game/GameComponents/PhaserGame/Managers/StudentManager';
import CosmeticShop from '@/game/GameComponents/PhaserGame/Scenes/CosmeticShop/CosmeticShop';
import SettingsPanel from '@/game/GameComponents/PhaserGame/Scenes/Settings/SettingsPanel';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import {
  biomeKeys,
  getBiomeFromStudentLevel,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';
import Mentor from '@/game/prefabs/World/Mentors/Mentor';
import Player from '@/game/prefabs/World/Player';
import WorldNode from '@/game/prefabs/World/WorldNode';
import Login from '@/game/scenes/Login/Login';
import PlayerInventory from '@/game/scenes/PlayerInventory/PlayerInventory';
import _ from 'lodash';
/* END-USER-IMPORTS */

export default class LevelMap extends Phaser.Scene {
  constructor() {
    super('LevelMap');

    /* START-USER-CTR-CODE */
    //this.targetNode = null;
    this.activeNode = null;
    this.targetNPC = null;
    this.onTargetNodeReached = () => {};
    this.onTargetNPCReached = () => {};
    this.handleCompleteCurrentLevel = () => {};
    this.onGameStarted = () => {};
    this.unsubscribeFromStore = () => {};
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // guidancePanel
    const guidancePanel = new GuidancePanel(this, 0, 0);
    this.add.existing(guidancePanel);
    guidancePanel.visible = false;

    // hUD
    const hUD = new HUD(this, 0, 0);
    this.add.existing(hUD);
    hUD.visible = true;

    // dialogue
    const dialogue = new npcDialogue(this, 480, 608);
    this.add.existing(dialogue);
    dialogue.scaleX = 1;
    dialogue.scaleY = 1;
    dialogue.visible = false;

    // walkthroughPanel
    const walkthroughPanel = new WalkthroughPanel(this, 0, -32);
    this.add.existing(walkthroughPanel);
    walkthroughPanel.visible = false;

    // nextLevelModal
    const nextLevelModal = new NextLevelModal(this, 0, 0);
    this.add.existing(nextLevelModal);
    nextLevelModal.visible = false;

    // dailiesPanel
    const dailiesPanel = new DailiesPanel(this, 0, 16);
    this.add.existing(dailiesPanel);
    dailiesPanel.visible = false;

    // rewardFeedbackPanel
    const rewardFeedbackPanel = new RewardFeedbackPanel(this, 0, 0);
    this.add.existing(rewardFeedbackPanel);
    rewardFeedbackPanel.visible = false;

    // masteriesPanel
    const masteriesPanel = new MasteriesPanel(this, 0, 0);
    this.add.existing(masteriesPanel);
    masteriesPanel.visible = false;

    // lessonPanel
    const lessonPanel = new LessonPanel(this, 0, 0);
    this.add.existing(lessonPanel);
    lessonPanel.visible = false;

    // mentorIntroductionPanel
    const mentorIntroductionPanel = new MentorIntroductionPanel(this, 0, 0);
    this.add.existing(mentorIntroductionPanel);
    mentorIntroductionPanel.visible = false;

    // quitToMenuModal
    const quitToMenuModal = new QuitToMenuModal(this, 0, -32);
    this.add.existing(quitToMenuModal);
    quitToMenuModal.visible = false;

    this.guidancePanel = guidancePanel;
    this.hUD = hUD;
    this.dialogue = dialogue;
    this.walkthroughPanel = walkthroughPanel;
    this.nextLevelModal = nextLevelModal;
    this.dailiesPanel = dailiesPanel;
    this.rewardFeedbackPanel = rewardFeedbackPanel;
    this.masteriesPanel = masteriesPanel;
    this.lessonPanel = lessonPanel;
    this.mentorIntroductionPanel = mentorIntroductionPanel;
    this.quitToMenuModal = quitToMenuModal;

    this.events.emit('scene-awake');
  }

  private guidancePanel!: GuidancePanel;
  private hUD!: HUD;
  private dialogue!: npcDialogue;
  private walkthroughPanel!: WalkthroughPanel;
  private nextLevelModal!: NextLevelModal;
  private dailiesPanel!: DailiesPanel;
  private rewardFeedbackPanel!: RewardFeedbackPanel;
  private masteriesPanel!: MasteriesPanel;
  private lessonPanel!: LessonPanel;
  private mentorIntroductionPanel!: MentorIntroductionPanel;
  private quitToMenuModal!: QuitToMenuModal;

  /* START-USER-CODE */

  static TILEMAP_ID: string;
  levelScene: TilemapScene | null = null;
  character: Phaser.Types.Physics.Arcade.SpriteWithDynamicBody | null = null;
  characterDoll: any;
  targetNode: WorldNode | Portal | Phaser.GameObjects.Container | null = null;
  activeNode: WorldNode | null;
  targetNPC: Phaser.GameObjects.Sprite | null;
  onTargetNodeReached: (node: WorldNode) => void;
  onTargetNPCReached: (node: WorldNode) => void;
  handleCompleteCurrentLevel: () => void;
  onGameStarted: (node: WorldNode) => void;
  unsubscribeFromStore: () => void;
  startPositions: any;
  moveToX?: number;
  moveToY?: number;
  player: Player | undefined;
  tutorializationManager?: TutorializationManager;

  static ambienceSound: Phaser.Sound.BaseSound | null;
  static musicSound?: Phaser.Sound.BaseSound;

  create() {
    this.editorCreate();

    // Default states for these panels.
    this.rewardFeedbackPanel.setVisible(false);
    this.dailiesPanel.setVisible(false);
    this.quitToMenuModal.setVisible(false);
    this.mentorIntroductionPanel.setVisible(false);
    this.lessonPanel.setVisible(false);
    this.walkthroughPanel.setVisible(false);
    this.masteriesPanel.setVisible(false);
    this.guidancePanel.setVisible(true);

    // Tell the HUD about the level map.
    this.hUD.controller.init({ levelMap: this });

    // Initialize cursors.
    this.initializeCursors();

    this.loadTilemap();

    this.handleCompleteCurrentLevel = () => {
      EventBus.emit(GAME_EVENTS.COMPLETED_CURRENT_LEVEL);
      // Wait until the game state has updated before we restart the level.
      EventsManager.registerEventOnce(
        this,
        GAME_EVENTS.GENERAL_GAME_STATE_UPDATED_AFTER_LEVEL_COMPLETE,
        () => {
          this.restartLevel();
        },
        this,
      );
    };

    // Disable walkthrough (it will be enabled when entering a new biome, if required.)
    this.walkthroughPanel.setVisible(false);

    // Set up event listeners
    this.events.once('destroy', this.handleLevelDestroyed, this);
    this.events.once('shutdown', this.handleLevelShutdown, this);

    this.events.on('resume', () => {
      this.resume();
    });

    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.MINIGAME_STARTED,
      this.handleGameStarted,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.PLAYER_REQUESTED_GUIDANCE_CUTSCENE,
      this.handlePlayerRequestedGuidanceCutscene,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.PLAYER_REQUESTED_OPEN_DAILIES_PANEL,
      this.handlePlayerRequestedOpenDailiesPanel,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.PLAYER_REQUESTED_QUIT_MAIN_LEVEL,
      this.handlePlayerRequestedQuitMainLevel,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.ENTERED_NEW_BIOME,
      this.handleEnteredNewBiome,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.PLAYER_CONFIRMED_QUIT_MAIN_LEVEL,
      this.handleQuitMap,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.PLAYER_REQUESTED_HUD_WALKTHROUGH,
      this.handlePlayerRequestedHudWalkthrough,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.COSMETIC_SHOP_OPENED,
      this.handleCosmeticShopOpened,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.NODE_COMPLETED,
      this.rewardFeedbackCheck,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.INVENTORY_OPENED,
      this.handlePlayerInventoryOpened,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.INVENTORY_CLOSED,
      this.handlePlayerInventoryClosed,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.COSMETIC_SHOP_CLOSED,
      this.handleCosmeticShopClosed,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.SETTINGS_PANEL_OPENED,
      this.handleSettingsPanelOpened,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.SETTINGS_PANEL_CLOSED,
      this.handleSettingsPanelClosed,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.PLAYER_REQUESTED_COMPLETE_ALL_NODES,
      this.restartLevel,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.USER_LOGOUT,
      this.handleQuitMap,
      this,
    );
    EventsManager.registerEventOn(
      this,
      GAME_EVENTS.DUEL_ENDED,
      this.rewardFeedbackCheck,
      this,
    );

    // Set up Tutorialization Manager
    this.tutorializationManager = new TutorializationManager({
      scene: this,
      cutscene: 'overview-cutscene-1',
    }).RunLevelMapTutorialization();
  }

  initializeCursors() {
    this.input.setDefaultCursor(
      `url(${uiAssetsPath}cursors/glove_pointer_64_64.png), auto`,
    );
    this.input.on('pointerdown', () => {
      const cursor = this.game.canvas.style.cursor;
      let clickCursor = '';
      if (
        cursor ===
        'url("/game_assets//sprites/phaser_game/phaser_game_ui/cursors/glove_pointer_64_64.png"), auto'
      ) {
        clickCursor = `url(${uiAssetsPath}cursors/glove_pointer_64_64-click.png), auto`;
        this.input.setDefaultCursor(clickCursor);
      } else if (
        cursor ===
        'url("/game_assets/sprites/phaser_game/phaser_game_ui/cursors/glove_pointer_64_64-hover.png"), auto'
      ) {
        clickCursor = `url(${uiAssetsPath}cursors/glove_pointer_64_64-hover-click.png), auto`;
        this.input.setDefaultCursor(clickCursor);
      }
    });
    this.input.on('pointerup', () => {
      const cursor = this.game.canvas.style.cursor;
      let clickCursor = '';
      if (
        cursor ===
        'url("/game_assets//sprites/phaser_game/phaser_game_ui/cursors/glove_pointer_64_64-click.png"), auto'
      ) {
        clickCursor = `url(${uiAssetsPath}cursors/glove_pointer_64_64.png), auto`;
        this.input.setDefaultCursor(clickCursor);
      } else if (
        cursor ===
        'url("/game_assets//sprites/phaser_game/phaser_game_ui/cursors/glove_pointer_64_64-hover-click.png"), auto'
      ) {
        clickCursor = `url(${uiAssetsPath}cursors/glove_pointer_64_64-hover.png), auto`;
        this.input.setDefaultCursor(clickCursor);
      }
    });
  }

  restartLevel() {
    getSceneManager()?.restartScene('LevelMap', true);
  }

  loadTilemap() {
    // get the tilemap for the specific level from the store.
    const student = getStudent();
    const studentID = student.id;
    const mapsCompleted = student.mapsCompleted;
    const ssLevel = student.level;
    const tilemapScene = getTilemapLevel(studentID!, mapsCompleted, ssLevel);
    const key = tilemapScene.key;

    EventsManager.registerEventOnce(
      this,
      GAME_EVENTS.TILEMAP_LEVEL_INITIALIZED,
      this.handleLevelInitialized,
      this,
    );

    getSceneManager()?.launchSubScene(
      'LevelMap',
      key,
      tilemapScene.scene,
      'gameplay',
    );
    //getSceneManager()?.launchSubScene('LevelMap', 'Level30', Level30, 'gameplay');
    getSceneManager()?.getMainScene().scene.bringToTop(this.scene.key);
    this.levelScene = this.scene.get(key) as TilemapScene;
    LevelMap.TILEMAP_ID = key;
  }

  async rewardFeedbackCheck() {
    // Show mastery feedback if required.
    const lastMasteredGame = getStudent().lastMasteredGame;
    if (lastMasteredGame) {
      await waitForSeconds(this.time, 0.4);
      EventBus.emit(GAME_EVENTS.MASTERED_NEW_MINIGAME, lastMasteredGame);
    }

    await waitForSeconds(this.time, 2);
    RewardsManager.CheckRewards();
  }

  // Performs all of the level map initialization.
  handleLevelInitialized(data: any) {
    this.player = data.player;

    this.scene.bringToTop();
    if (!this.levelScene) return;

    // Player setup
    const { player } = this;
    const tilemap = this.levelScene.tilemapRef;
    player!.onNodeReachedCallback = this.handleNodeReached;
    player!.onNodeLeftCallback = this.handleNodeLeft;
    this.levelScene.physics.world.setBounds(
      8,
      32,
      tilemap?.widthInPixels! - 8,
      tilemap?.heightInPixels! - 32,
      true,
      true,
      true,
      true,
    );

    // Camera setup

    // Mentor setup
    const mentor = this.levelScene.mentorRef;
    if (mentor) {
      const mentorBody = mentor.list[0];
      mentorBody.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
      mentorBody.on('pointerdown', () => {
        this.handleNodeClicked(mentor);
      });
    }

    // Node setup
    // Create nodes/NPCs.

    for (var i = 0; i < this.levelScene.nodes.length; i++) {
      this.levelScene.nodes[i].initialize({
        index: i,
        behavior: _.sample(['pace', 'idle']) as 'pace' | 'idle',
        distance: 25 + Math.random() * 25,
        duration: 1000 + Math.random() * 1000,
        callback: this.handleNodeClicked,
        gameStartedCallback: this.handleGameStarted,
      });
    }

    // Portal setup.
    if (data.portal) data.portal.callback = this.handleNodeClicked;

    // Rewards initialization.
    this.rewardFeedbackCheck();
  }

  handleEnteredNewBiome() {
    this.mentorIntroductionPanel.open();
    if (!getStudent().tutorialization.hasViewedHudWalkthrough) {
      this.waitToShowHudWalkthrough();
    }
  }

  handleGameStarted = (node: WorldNode) => {
    //this.sound.pauseAll();
    //this.targetNode = null;
    this.activeNode = null;
    return node;
  };

  handlePlayerRequestedOpenDailiesPanel = () => {
    this.dailiesPanel.open();
  };

  handlePlayerRequestedQuitMainLevel = () => {
    this.quitToMenuModal.open();
  };

  handleNodeClicked = (
    node: WorldNode | Portal | Phaser.GameObjects.Container,
  ) => {
    this.targetNode = node;
    if (this.player) {
      this.player.setTargetNode(node);
      if (node instanceof WorldNode) {
        node.handleNodeClicked();
        this.tweens.killTweensOf(node.nPC!);
      }
    }
  };

  handleNodeReached = async (
    node: WorldNode | Portal | Phaser.GameObjects.Container,
  ) => {
    // Todo - this is potentially going to get out of control. Would be much better
    // to fire events from the types of objects that we can interact with, and
    // listen to them in the components that should act upon the player interacting
    // with them.
    if (node instanceof WorldNode) {
      const nodeStatus = node.npcStatus!;
      this.activeNode = node;

      // Wait just a fraction of a second for the interaction to occur.
      await waitForSeconds(this.time, 0.2);

      // Set NPC facing.
      node.handlePlayerReachedNode(this.player?.body!);
      this.dialogue.controller?.configure({
        gameStartedCallback: this.handleGameStarted,
        node: node,
        nodeStatus: nodeStatus,
      });
    } else if (node instanceof Portal) {
      if (GameInstance.instance.getShouldPlayCustomLevel()) {
        await GameInstance.instance.recordPlaythroughCompleted();
        GameInstance.instance.customLevel = null;
        this.restartLevel();
      } else {
        this.nextLevelModal.open(() => {
          this.handleCompleteCurrentLevel();
        });
      }
    } else if (node instanceof Phaser.GameObjects.Container) {
      if (node instanceof Mentor) {
        await waitForSeconds(this.time, 0.2);
        this.handleMentorInteraction();
      }
    }

    this.targetNode = null;
  };

  handleNodeLeft = (
    node: WorldNode | Portal | Phaser.GameObjects.Container,
  ) => {
    if (node instanceof WorldNode) {
      this.dialogue.setVisible(false);
      this.activeNode?.handleModalClosed(node);
    } else if (node instanceof Portal) {
      getSceneManager()?.pauseScene('NextLevelModalScene');
    }
    this.activeNode = null;
  };

  handlePlayerRequestedGuidanceCutscene() {}

  handleQuitMap() {
    GameInstance.instance.generalGameState.optedIntoCustomLevel = false;
    getSceneManager()?.launchScene('Login', Login, {
      type: 'gameplay',
      stopActiveScene: true,
      removeSubScenes: true,
    });
  }

  handleMentorInteraction() {
    this.lessonPanel.controller.startNewLesson();
  }

  handleCosmeticShopOpened() {
    getSceneManager()?.launchOverlayScene(this, 'CosmeticShop', CosmeticShop);
  }

  handlePlayerInventoryOpened() {
    getSceneManager()?.launchOverlayScene(
      this,
      'PlayerInventory',
      PlayerInventory,
    );
  }

  handlePlayerInventoryClosed() {
    // TODO make a UI manager.
    if (getSceneManager()?.activeSceneKey === 'LevelMap') {
      getSceneManager()?.resumeScene('LevelMap');
    }
  }

  handleCosmeticShopClosed() {
    // TODO make a UI manager.
    if (getSceneManager()?.activeSceneKey === 'LevelMap') {
      getSceneManager()?.resumeScene('LevelMap');
    }
  }

  handleSettingsPanelOpened() {
    getSceneManager()?.launchOverlayScene(this, 'SettingsPanel', SettingsPanel);
  }

  handleSettingsPanelClosed() {
    // TODO make a UI manager.
    if (getSceneManager()?.activeSceneKey === 'LevelMap') {
      getSceneManager()?.resumeScene('LevelMap');
    }
  }

  handlePlayerRequestedHudWalkthrough() {
    trackMixpanelEvent('Player requested HUD walkthrough');
    this.walkthroughPanel.setVisible(true);
    this.walkthroughPanel.reset();
  }

  waitToShowHudWalkthrough() {
    EventsManager.registerEventOnce(
      this,
      GAME_EVENTS.MENTOR_INTRODUCTION_PANEL_CLOSED,
      () => {
        this.walkthroughPanel.start();
        EventBus.emit(GAME_EVENTS.PLAYER_VIEWED_HUD_WALKTHROUGH);
      },
      this,
    );
  }

  resume() {}

  handleLevelShutdown() {
    this.levelScene?.handleShutdown();
  }

  handleLevelDestroyed() {
    if (this.unsubscribeFromStore) {
      this.unsubscribeFromStore();
    }
    EventBus.emit(GAME_EVENTS.LEVEL_MAP_QUIT);
    this.tutorializationManager = undefined;
    GameInstance.destroyGameInstance();
    this.levelScene?.handleShutdown();
    this.levelScene = null;
  }

  handleMusicToggled(newValue: boolean) {
    // Need a better way to manage this.
    if (
      !this.scene.isPaused(LevelMap.TILEMAP_ID) ||
      this.scene.isVisible('Duel')
    ) {
      PhaserAudioManager.setMusicPlaying(newValue);
    }
  }

  handleSFXToggled(newValue: boolean) {
    StudentManager.instance.updateSettings({
      ...getStudent().settings,
      audio: {
        ...getStudent().settings.audio,
        sfxOn: newValue,
      },
    });
    if (!this.scene.isPaused(LevelMap.TILEMAP_ID)) {
      PhaserAudioManager.setAmbiencePlaying(newValue);
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

/*
  Categorize tilemaps by biome, generate a biome based on student level, then 
  use a hash of the student ID + maps completed to select a tilemap from that biome. 
  This way, students will get the same tilemap each time for a given level, but different 
  students at the same level will likely get different tilemaps.
*/
export function getTilemapLevel(
  studentID: string,
  mapsCompleted: number,
  ssLevel: number,
) {
  // Get the biome from the student's level.
  // Generate the hash function.
  // Get a subset of the tilemaps that correspond to the biome.
  // Use the hash to select a tilemap from that subset.
  // Return the selected tilemap object.

  // Set this to the index of a tilemap you want to test, or
  // leave as undefined to use the normal selection logic.
  const overrideTilemap: number | undefined = undefined;
  const isDev = process.env.NODE_ENV === 'development';
  const shouldOverride =
    isDev &&
    overrideTilemap !== undefined &&
    overrideTilemap < TilemapLevels.length;
  if (!shouldOverride) {
    // Logic for normal tilemap selection based on biome and hash.
    const input = `${studentID}${mapsCompleted}`;
    const biome = getBiomeFromStudentLevel(ssLevel);

    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = (hash * 31 + input.charCodeAt(i)) % 1000000007;
    }

    const biomeTilemaps = TilemapLevels.filter(
      (tilemap) => tilemap.biome === biomeKeys[biome],
    );
    const tilemapIndex = hash % biomeTilemaps.length;
    return biomeTilemaps[tilemapIndex];
  } else {
    // Logic for overriding tilemap selection, for testing purposes.
    return TilemapLevels[overrideTilemap!];
  }
}
